<app-page-header
  [title]="pageTitle"
  [breadcrumbs]="breadcrumb"
></app-page-header>


<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12">

      <mat-card class="discrepancies">
        <mat-card-header class="loading-header" [ngClass]="{ loading: loading }">
          <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        </mat-card-header>


        <h2>
          Clear bciti data that is bind to an External System
        </h2>

        <div class="payment-cards-container" *ngIf="!loading">
          <div *ngFor="let connector of connectorsPurgeable"  class="payment-cards-item">
              <app-toolbar
                  [toolbarTitle]="connector.tag"
                  [toolbarButtonText]="buttonText"
                  (onAction)="handlePurge($event, connector.tag)"
              ></app-toolbar>
          </div>
        </div>

      </mat-card>

    </div>
  </div>
</section>


